import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import DOMPurify from 'dompurify';

const baseUrl = "https://api.shabdtoday.com/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }
  return text;
};

const local = "https://localhost:44351/api/home/getdesh"
const online = "https://api.shabdtoday.com/api/home/getdesh"
const clicklocal = "https://api.shabdtoday.com/api/home/update-viewcount"
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"


const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};


const NationalCards = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const observer = useRef();

  const fetchNews = async () => {
    if (!hasMore || fetching) return;

    setFetching(true);
    try {
      const response = await axios.get(`${online}?page=${page}&limit=5`);

      if (response.data && response.data.length > 0) {
        setNews((prevNews) => {
          const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
          const newNews = response.data.filter((item) => !existingIds.has(item.mainKhabarId));
          return [...prevNews, ...newNews];
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching news:", error.message);
    }
    setFetching(false);
    setLoading(false);
  };

  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchNews();
      }
    });

    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);

    return () => observer.current && observer.current.disconnect();
  }, [news]);
  const renderHtmlContent = (html) => {
    const sanitizedHtml = DOMPurify.sanitize(html);
    return { __html: sanitizedHtml };
  };



  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      const response = await axios.post(`${clickonline}`, {
        mainKhabarId: mainKhabarId
      });

      if (response.status === 200) {
        // console.log("View count updated successfully", response.data);
        window.location.href = `/News-Details/${slug}`;
      } else {
        console.error("Failed to update view count", response.data);
      }
    } catch (error) {
      console.error("Error updating view count:", error.response ? error.response.data : error.message);
    }
  };

  const handleNewsClick = (trendingTagId) => {
    navigate(`/NewsDetails/${trendingTagId}`);
  };

  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const seconds = date.getSeconds();
    const minute = date.getMinutes();
    var hour = date.getHours();
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
  };
  const getTimeAgoInHindi = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} सेकंड पहले`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} मिनट पहले`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} घंटे पहले`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays} दिन पहले`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} महीने पहले`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} साल पहले`;
  };

  const generateShareLinks = (mainKhabarId, newsTag) => {
    const encodednewsTag = encodeURIComponent(newsTag);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodednewsTag}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodednewsTag} ${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodednewsTag}&url=${url}`,
      instagram: `https://www.instagram.com/`
    };
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        {/* <Circles height="30" width="30" color="#f7265c" ariaLabel="loading" visible={true} /> */}
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <Helmet>
        <title>राष्ट्रीय समाचार – देश की ताज़ा खबरें | ShabdToday</title>

        <meta name="title" content="आज की ताज़ा राष्ट्रीय खबरें – देश बदलने वाली सबसे बड़ी हिंदी अपडेट!" />
        <meta name="description" content="भारत की हर महत्वपूर्ण राष्ट्रीय खबर अब एक ही जगह! राजनीति, नीति-निर्णय, सामाजिक बदलाव, अर्थव्यवस्था और देश-दुनिया के राष्ट्रीय मामलों की सबसे तेज़, सटीक और भावनात्मक हिंदी अपडेट पढ़ें। आज की हर वो खबर जो आपके देश और भविष्य को प्रभावित करती है — अब सिर्फ एक क्लिक में।" />
        <meta name="keywords" content="राष्ट्रीय समाचार, देश की खबरें, देश की ताज़ा खबरें, भारत न्यूज़" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ShabdToday Team" />

        <link rel="canonical" href="https://shabdtoday.com/National-News" />

        <meta property="og:title" content="राष्ट्रीय समाचार – देश की ताज़ा खबरें | ShabdToday" />
        <meta property="og:description" content="राजनीति, मुद्दों और देश की प्रमुख खबरों का अपडेट।" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://shabdtoday.com/National-News" />
        <meta property="og:image" content="https://shabdtoday.com/design/images/National-cover.webp" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "National News – ShabdToday",
            "url": "https://shabdtoday.com/National-News",
            "description": "भारत की राष्ट्रीय खबरें और प्रमुख अपडेट।",
            "publisher": {
              "@type": "Organization",
              "name": "ShabdToday",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shabdtoday.com/design/images/logo-s.webp"
              }
            }
          })}
        </script>

        <h1 style={{ color: "crimson", marginLeft: 10 }}>राष्ट्रीय समाचार हिंदी में</h1>
        <h2 style={{ marginLeft: 10 }}>देश की राजनीति और प्रमुख अपडेट</h2>
        <h3 style={{ marginLeft: 10 }}>भारत की मुख्य खबरें सबसे तेज़</h3>
      </Helmet>

      <div className="row vc_row">
        <div className="ak_vc_container">
          <div className="wpb_column ak_column_3 vc_column_container">
            <div className="ak_vc_wrapper wpb_wrapper">
              <div
                className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
                id="block_65f7f61f36732_2"
              >
                <div className="ak-block-inner clearfix">
                  <div className="ak-block-posts clearfix">
                    {news.map((post) => {
                      const shareLinks = generateShareLinks(post.mainKhabarId, post.newsTag);
                      return (

                        <article key={post.mainKhabarId} className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news" style={{ border: "0.5px solid #d4d4d4ff", marginBottom: "20px" }}>
                          <div className="ak-module-inner clearfix">
                            <div className="ak-module-featured">

                              <div className="ak-module-details">
                                <h1 className="ak-module-title mb-3">
                                  <Link
                                    to={`/News-Details/${post.slug}`}
                                    onClick={(e) => {
                                      e.preventDefault(); // Prevent default navigation
                                      handleNewsClick2(post.slug, post.mainKhabarId);
                                    }}
                                    rel="bookmark"
                                    aria-label="Shabd Today"
                                    title={stripHtmlTags(post.newsTag)}
                                  >
                                    <span className="responsive-font" style={{ lineHeight: "30px" }} dangerouslySetInnerHTML={renderHtmlContent(post.newsTag)} />
                                  </Link>
                                </h1>
                              </div>

                              <div className="ak-featured-cover">
                                <Link
                                  to={`/News-Details/${post.slug}`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleNewsClick2(post.slug, post.mainKhabarId);
                                  }}
                                  className="ak-featured-link"
                                  rel="bookmark"
                                  aria-label="Shabd Today"
                                  title={stripHtmlTags(post.newsTag)}
                                >
                                  <div className="ak-featured-thumb size-500">
                                    <img
                                      src={baseUrl + post.newsImage}
                                      alt={stripHtmlTags(post.newsTag, 150)}
                                      width={410}
                                      height={300}
                                    />
                                  </div>
                                </Link>
                              </div>
                              <div className="ak-module-terms badge">
                              </div>
                            </div>

                          </div>

                        </article>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
        {fetching && <p>Loading more news...</p>}
        {!hasMore && <p>No more news available.</p>}
      </div>
    </div>
  );

};
export default NationalCards